// Заготовка для компонента информации о группировке заказов
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { SimpleTableComponent } from '../../../../components/simple-table';
import { getOrderGroupInfoSelector, getIsOrderGroupInfoLoadingSelector } from '../../selectors';
import { CustomLoader } from '../../../../components/custom-loader';
import { COLUMNS } from '../../constants';

const OrderGroupInfo = ({ rows, isLoading }) => {
	if (isLoading) return <CustomLoader />;
	if (rows.length === 0) return null;

	return (
		<>
			<SimpleTableComponent rows={rows} columns={COLUMNS} isTableDataLoading={isLoading} />
		</>
	);
};

OrderGroupInfo.propTypes = {
	rows: PropTypes.array,
	isLoading: PropTypes.bool,
};

const mapStateToProps = createStructuredSelector({
	rows: getOrderGroupInfoSelector(),
	isLoading: getIsOrderGroupInfoLoadingSelector(),
});

export default connect(mapStateToProps)(OrderGroupInfo);
